const $ = window.$
// const url = '/lock/upload'
// const url = '/api/lock/upload'
export default {
  upload (url, file, succCallback, failCallback, params) {
    var formData = new window.FormData()
    if (params) {
      for (let param of params) {
        formData.append(param.key, param.val)
      }
    }
    formData.append('attachment', file)
    $.ajax({
      url: url,
      type: 'POST',
      cache: false,
      data: formData,
      processData: false,
      contentType: false,
      dataType: 'json'
    }).success(function (res) {
      console.log(res)
      let state = res.state
      if (state.code === 2000000 && state.result === 0) {
        if (succCallback && typeof succCallback === 'function') {
          succCallback(res.data)
        }
      } else {
        if (failCallback && typeof failCallback === 'function') {
          failCallback(res)
        }
      }
    }).fail(function (res) {
      if (failCallback && typeof failCallback === 'function') {
        failCallback(res)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/lib/utils/fileutil.js